export const commonConstants = {
    REQUEST: '/REQUEST',
    CONVERT: '/CONVERT',
    SUCCESS: '/SUCCESS',
    FAILURE: '/FAILURE',
    SETUP: '/SETUP'
}